<template>
  <v-row>
    <v-col v-if="getHasLabel">
      <span style="font-size:14px">{{ labelDisp }}</span><span style="margin-left:5px; font-weight:500" v-bind:style="{ color: getHighlightColor }"><b>{{ value }}</b></span>
    </v-col>
    <v-col v-if="!getHasLabel">
      <span v-bind:style="{ color: getHighlightColor }">{{ value }}</span>
    </v-col>
  </v-row>
</template>
<script>
  //WrsLabel.vue
  export default {
    props: {
      label: {
        type: String,
        default: "",
      },
      value: {
        type: [String, Number, Boolean],
        default: ""
      },
      isHighlighted: {
        // type: String,
        type: Boolean,
        default: false
      },
      highLightColor: {
        type: String,
        default: "black",
      },
      hasLabel: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      labelDisp: function () {
        if (this.label == "") {
          return "";
        } else {
          return this.label + " :";
        }
      },
      getHighlightColor: function () {
        if (this.isHighlighted) {
          return this.highLightColor;
        } else {
          return "";
        }
      },
      getHasLabel: function () {
        return this.hasLabel;
      },
    }
  }
</script>
